import { useAttemptListener } from 'dev-masters-react-kit'
import { listenerMiddleware, useAppDispatch } from '../../utils/redux/store'

import { AsyncThunk } from '@reduxjs/toolkit'
import { message } from 'antd'
import { useNavigate } from 'react-router-dom'
import {
  CreateFolderDTO,
  PlaylistFolder
} from '../../utils/redux/moodsSlice'
import PlaylistFolderForm from '../PlaylistFolderForm/PlaylistFolderForm'

export type UploadedFolderDestination = 'moods'|'businesses'|'playlists'|'styles'|'daytimes'
export interface NewFolderProps {
  attempt: AsyncThunk<PlaylistFolder, CreateFolderDTO, AsyncThunkConfig>
  uploadedDestination: UploadedFolderDestination
  successPath: string
}
export default function NewFolder({
  attempt,
  successPath,
  uploadedDestination,
}: NewFolderProps) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const isLoading = useAttemptListener({
        listenerMiddleware: listenerMiddleware,


    attempt: attempt,
    onFulfilled: () => {
      message.success('Folder has been created successfully!')
      navigate(successPath)
    },
  })

  function onFinish(values: CreateFolderDTO) {
    dispatch(attempt(values))
  }
  return (
    <PlaylistFolderForm
      onFinish={onFinish}
      isLoading={isLoading}
      uploadedDestination={uploadedDestination}
    />
  )
}
